import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCodeLabel11({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="LABEL11 KARTI" />
}
